<template>
  <div class="doc">
    <div class="banner">
      <div class="banner-text content-1200 flex-center flex-column H100">
        <div class="title">标准文档</div>
        <div class="desc color-level4 fontSize16">
          金标联盟致力于构建完整的标准化体系，通过制定统一的标准规范，为行业健康发展奠定坚实基础，打造具有示范意义的标杆案例。这一标准化建设路径将有效提升行业整体水平，促进行业向规范化、高质量方向升级。
        </div>
      </div>
    </div>
    <reveal-animation>
      <Document/>
    </reveal-animation>
  </div>
</template>
<script>
import Document from "./components/Document";
import RevealAnimation from "@/components/common/RevealAnimation.vue";

export default {
  components: {RevealAnimation, Document}
}
</script>
<style scoped lang="scss">
.doc {
  width: 100%;
  background: #FAFAFA;

  .banner {
    width: 100%;
    height: 356px;
    background-image: url("~@/assets/img/doc/banner.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    &-text {
      align-items: start;
    }

    .title {
      font-weight: 800;
      font-size: 48px;
      margin-bottom: 12px;
      background: linear-gradient(359.9999999898547deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      -webkit-text-fill-color: transparent;
    }

    .desc {
      width: 644px;
      line-height: 27px;
    }
  }
}
</style>
